import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';
import utils from '@/utils/index';

import './utils/directives';
import { 
    Area, 
    Button, 
    CellGroup , 
    Dialog, 
    Loading, 
    Popup, 
    Toast, 
    Field ,
    Form,
    RadioGroup, 
    Radio, 
    Icon,
    Cell,
    Swipe,
    SwipeItem,
    Image as VanImage,
    Lazyload,
    Checkbox, 
    CheckboxGroup,
    Picker,
    PullRefresh,
    List
} from 'vant';
import 'vant/lib/index.css';

dmWebSdk.init({
    platform: 'h5',
    appKey: '0eb47097-64f5-414b-ae37-3f998958a9ea',
    packageName: 'com.anoah.market.yjhx',
    appName: '以旧换新活动',
    productID: '2023050412224612345',
    heatmap: { pagemap: false, clickmap: false },
    name: 'yjhx',
});
dmWebSdk.init({
    platform: 'wxmini',
    appKey: '6fd9509e-d39b-4108-9010-c762cacd2d29',
    packageName: 'com.anoah.faceConsulting',
    appName: '优学成长学苑',
    productID: '1896523547896541254',
    heatmap: { pagemap: false, clickmap: false },
    name: 'yxczxy',
});
dmWebSdk.init({
    platform: 'h5',
    appKey: 'deb273f4-7875-4164-bd7a-8e9210bbc05f',
    packageName: 'com.anoah.market.ktbj',
    appName: '课堂笔记课程',
    productID: '20260612160900123456',
    heatmap: { pagemap: false, clickmap: false },
    name: 'ktbj',
});

Vue.prototype.$utils = utils;
Vue.config.productionTip = false;

// 麻烦按照字母顺序排序，方便合并代码
Vue.use(Area)
    .use(Button)
    .use(CellGroup)
    .use(Dialog)
    .use(Field)
    .use(Form)
    .use(Loading)
    .use(Popup)
    .use(Icon)
    .use(Radio)
    .use(RadioGroup)
    .use(Toast)
    .use(Cell)
    .use(Swipe)
    .use(SwipeItem)
    .use(Lazyload)
    .use(VanImage)
    .use(Picker)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(PullRefresh)
    .use(List);
window.vue = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
